import { isMeinBuero } from '@/utils/build-env'

export const dateConstants = {
  YEAR: 'year',
  MONTH: 'month',
  QUARTER: 'quarter',
  WEEK: 'week',
  DAY: 'day',
  FOREVER: 'forever',
}

export const customerTypes = {
  COMPANY: 'company',
  PERSON: 'person',
}

export const directDebitMandateStates = {
  ACTIVE: 'active',
  PENDING: 'pending',
  EXPIRED: 'expired',
  CANCELLED: 'cancelled',
  CANCELLING: 'cancelling',
}

export const directDebitMandateTypes = {
  ONE_OFF: 'oneOff',
  RECURRING: 'recurring',
}

export const addressTypes = {
  BILLING: 'billing',
  DELIVERY: 'delivery',
}

export const columnViewStates = {
  COLUMN_VIEW_STATE_DISPLAY: 'display',
  COLUMN_VIEW_STATE_FORM: 'form',
}

export const recipientStates = {
  RECIPIENT_STATE_EMPTY: 'empty',
  RECIPIENT_STATE_FORM: 'form',
  RECIPIENT_STATE_SELECT: 'select',
  RECIPIENT_STATE_CUSTOMER_SELECTED: 'selected',
}

export const notesStates = {
  NOTES_DISPLAY_STATE: 'display',
  NOTES_FORM_STATE: 'form',
}

export const signatureTypes = {
  client: 'client',
}

export const errorTypes = {
  JsonSchemaValidation: 'JSONSchemaValidationError',
  FinanceApiError: 'FinanceApiError',
}

export const JsonSchemaValidationErrorTypes = {
  AdditionalProperty: 'additionalProperty',
  MissingProperty: 'missingProperty',
}

export const errorCodesWithMessages = [
  { type: 'INCORRECT', message: '%s ist falsch' },
  { type: 'INVALID', message: '%s ist nicht gültig' },
  { type: 'NO_INTEGER', message: 'Bitte gib eine valide Zahl ein' },
  { type: 'NO_NUMBER', message: 'Bitte gib eine valide Gleitkommazahl ein' },
  { type: 'NO_DATE', message: 'Bitte gib ein valides Datum ein' },
  { type: 'NO_DATETIME', message: 'Bitte gib ein valides Datum mit Uhrzeit ein' },
  { type: 'NO_STRING', message: 'Bitte gib einen validen Text ein' },
  { type: 'NOT_ALLOWED', message: '%s ist nicht gültig' },
  { type: 'NOT_FOUND', message: '%s existiert nicht' },
  { type: 'NOT_POSITIVE', message: 'Der eingegebene Wert muss positiv sein' },
  { type: 'REQUIRED', message: 'Dies ist ein Pflichtfeld' },
  { type: 'TOO_SMALL', message: 'Der eingegebene Wert ist zu klein' },
  { type: 'TOO_LARGE', message: 'Der eingegebene Wert ist zu groß' },
  { type: 'EXISTS', message: '%s existiert bereits' },
]

export const errorCodes = Object.freeze({
  TOO_MANY: 'TOO_MANY',
  OWNER: 'OWNER',
  REQUIRED: 'REQUIRED',
  NOT_EMPTY: 'NOT_EMPTY',
  INCORRECT: 'INCORRECT',
  INVALID: 'INVALID',
  NO_INTEGER: 'NO_INTEGER',
  NO_NUMBER: 'NO_NUMBER',
  NO_DATE: 'NO_DATE',
  NO_DATETIME: 'NO_DATETIME',
  NO_STRING: 'NO_STRING',
  NOT_ALLOWED: 'NOT_ALLOWED',
  NOT_FOUND: 'NOT_FOUND',
  NOT_POSITIVE: 'NOT_POSITIVE',
  NOT_LOCKED: 'NOT_LOCKED',
  NO_BOOLEAN: 'NO_BOOLEAN',
  NOT_CONFIRMED: 'NOT_CONFIRMED',
  TOO_SMALL: 'TOO_SMALL',
  TOO_LARGE: 'TOO_LARGE',
  IS_CONFIRMED: 'IS_CONFIRMED',
  EXISTS: 'EXISTS',
  MAX_REACHED: 'MAX',
  MAX_LENGTH_EXCEEDED: 'MAX_LENGTH_EXCEEDED',
  LOCKED: 'LOCKED',
  IN_USE: 'IN_USE',
  NOT_SUPPORTED: 'NOT_SUPPORTED',
  FINANCE_API_ERROR: 'FinanceApiError',
  NO_BIC: 'NO_BIC',
  NO_IBAN: 'NO_IBAN',
  TOO_LONG: 'TOO_LONG',
  NOT_VERIFIED: 'NOT_VERIFIED',
  // FLAG:useDocuAi — „In Prüfung zurücksetzen" refusals (see api receiptReviewCaseService):
  // the linked expense is already booked / the stored analysis cannot be re-derived.
  EXPENSE_BOOKED: 'EXPENSE_BOOKED',
  NO_ANALYSIS_RESULT: 'NO_ANALYSIS_RESULT',
  // FLAG:useDocuAi — booking-target switch rejected: the document is already linked to a receipt
  // in the opposite ledger (plan `review-booking-target` T8). Must exactly match the server constant value.
  BOOKING_TARGET_CONFLICT: 'BOOKING_TARGET_CONFLICT',
})

// button action ids
export const actionIds = {
  DOWNLOAD_X_CREDITNOTE: 'downloadXCreditNote',
  LOCK: 'lock',
  LOCK_AND_SEND_MAIL: 'lockAndEmail',
  LOCK_AND_DOWNLOAD: 'lockAndDownload',
  LOCK_AND_PRINT: 'lockAndPrint',
  EDIT: 'edit',
  SEND_EMAIL: 'sendEmail',
  PRINT: 'print',
  DOWNLOAD: 'download',
  DOWNLOAD_X_INVOICE: 'downloadXInvoice',
  DOWNLOAD_X_INVOICE_REPORT: 'downloadXInvoiceReport',
  SHIPPING: 'shipping',
  ADD_PAYMENT: 'addPayment',
  ASSIGN_PAYMENT: 'assignPayment',
  BANK_TRANSFER: 'bankTransfer',
  CREATE_DUNNING: 'createDunning',
  COPY_AND_EDIT: 'copyAndEdit',
  CANCEL: 'cancel',
  CREATE_CREDIT_NOTE: 'createCreditNote',
  DELETE: 'delete',
  DELETE_AND_CANCEL: 'deleteCancel',
  REGENERATE_PDF: 'regeneratePdf',
  START_RECURRING_INVOICE: 'startRecurringInvoice',
  END_RECURRING_INVOICE: 'endRecurringInvoice',
  REACTIVATE_RECURRING_INVOICE: 'reactivateRecurringInvoice',
  CREATE_DEPOSIT_INVOICE: 'createDepositInvoice',
  CREATE_CLOSING_INVOICE: 'createClosingInvoice',
  TO_INVOICE: 'toInvoice',
  TO_DEPOSIT_INVOICE: 'toDepositInvoice',
  TO_PROJECT: 'toProject',
  TO_ORDER: 'toOrder',
  ACCEPT_AND_CREATE_ORDER: 'acceptAndCreateOrder',
  TO_DELIVERYNOTE: 'toDeliveryNote',
  TO_DELIVERYNOTE_AND_INVOICE: 'toDeliveryNoteAndInvoice',
  ACCEPT: 'accept',
  REJECT: 'reject',
  RESET: 'reset',
  MARK_AS_DELIVERED: 'markAsDelivered',
  MARK_AS_PARTIALLY_DELIVERED: 'markAsPartiallyDelivered',
  E_SIGNATURE_MODULE: 'eSignatureModule',
  FULLSCREEN: 'fullscreen',
  MARK_AS_ORDERED: 'markAsOrdered',
  SUBMIT_DIRECT_DEBIT: 'submitDirectDebit',
  TO_PARTIAL_INVOICE: 'toPartialInvoice',
  TO_COLLECTIVE_DELIVERY_NOTE: 'toCollectiveDeliveryNote',
}

export const payKinds = {
  OPEN: 'open',
  CASH: 'cash',
  BANK: 'bank',
  CLEARING_ACCOUNT: 'clearingAccount',
  OFFLINE: 'offline',
}

// cancellation/ creditNote states
export const cancellationStates = {
  IN_PROGRESS: 'inProgress',
  OPEN: 'open',
  PAID: 'paid',
  PARTIALLYPAID: 'partiallyPaid',
}

// offer states
export const offerStates = {
  OPEN: 'open',
  ACCEPTED: 'accepted',
  REJECTED: 'rejected',
  INVOICED: 'invoiced',
  PROJECT_CREATED: 'projectCreated',
  ORDER_CREATED: 'orderCreated',
  PRINTED: 'printed',
  SELECTED: 'selected',
}

// invoice states
export const invoiceStates = {
  OPEN: 'open',
  DRAFT: 'draft',
  LOCKED: 'locked',
  CANCELLED: 'cancelled',
  CREDITED: 'credited',
  DUNNED: 'dunned',
  PAID: 'paid',
  PARTIALLYPAID: 'partiallyPaid',
  UNCOLLECTIBLE: 'uncollectible',
  PRINTED: 'printed',
  SENT: 'sent',
  RECURRINGINVOICETEMPLATE: 'recurringTemplate',
  PAIDCREDITNOTE: 'paidCreditnote',
}

export const invoiceTypes = {
  CASH_INVOICE: 'cashInvoice',
  CASH_CREDIT_NOTE: 'cashCreditNote',
  INVOICE: 'invoice',
}

// recurring invoice states
export const recurringInvoiceStates = {
  DRAFT: 'draft',
  STARTED: 'started',
  FINISHED: 'finished',
}

export const projectStates = {
  DRAFT: 'draft',
  STARTED: 'started',
  FINISHED: 'finished',
  PAID: 'paid',
}

export const deliveryNoteStates = {
  DRAFT: 'draft',
  DELIVERED: 'delivered',
  SENT: 'sent',
  PRINTED: 'printed',
}

export const orderStates = {
  OPEN: 'open',
  LOCKED: 'locked',
  PRINTED: 'printed',
  PARTIALLY_CHARGED: 'partiallyCharged',
  PARTIALLY_DELIVERED: 'partiallyDelivered',
  SENT: 'sent',
  INVOICED: 'invoiced',
  DELIVERED: 'delivered',
  INVOICECREATED: 'invoiceCreated',
  DELIVERYNOTECREATED: 'deliveryNoteCreated',
  DEPOSIT_INVOICE_CREATED: 'depositInvoiceCreated',
  CLOSING_INVOICE_CREATED: 'closingInvoiceCreated',
  PARTIAL_INVOICE_CREATED: 'partialInvoiceCreated',
}

export const letterStates = {
  DRAFT: 'draft',
  SENT: 'sent',
  PRINTED: 'printed',
}

export const purchaseStates = {
  OPEN: 'open',
  ORDERED: 'ordered',
  PARTIALLY_DELIVERED: 'partiallyDelivered',
  DELIVERED: 'delivered',
  PRINTED: 'printed',
  SENT: 'sent',
}

export const documentStates = {
  PRINTED: 'printed',
}
/**
 * @deprecated
 * TODO recheck in app
 */
export const serviceAgreement = {
  url: 'https://www.deltra.com/agb/',
}

export const transactionTypes = {
  TRANSACTION_TYPE_OFFER: 'offer',
  TRANSACTION_TYPE_CASH_INVOICE: 'cashInvoice',
  TRANSACTION_TYPE_INVOICE: 'invoice',
  TRANSACTION_TYPE_DUNNING: 'dunning',
  TRANSACTION_TYPE_CASH_CANCELLATION: 'cashCancellation',
  TRANSACTION_TYPE_CANCELLATION: 'cancellation',
  TRANSACTION_TYPE_CASH_CREDIT_NOTE: 'cashCreditNote',
  TRANSACTION_TYPE_CREDIT_NOTE: 'creditNote',
  TRANSACTION_TYPE_DEPOSIT_INVOICE: 'depositInvoice',
  TRANSACTION_TYPE_PARTIAL_INVOICE: 'partialInvoice',
  TRANSACTION_TYPE_CLOSING_INVOICE: 'closingInvoice',
  TRANSACTION_TYPE_RECURRING_INVOICE: 'recurringInvoice',
  TRANSACTION_TYPE_RECURRING_INVOICE_TEMPLATE: 'recurringInvoiceTemplate',
  TRANSACTION_TYPE_MANUAL_CREDIT_NOTE: 'manualCreditNote',
  TRANSACTION_TYPE_DELIVERY_NOTE: 'deliveryNote',
  TRANSACTION_TYPE_ORDER: 'order',
  TRANSACTION_TYPE_EXPENSE: 'expense',
  TRANSACTION_TYPE_REVENUE: 'revenue',
  TRANSACTION_TYPE_SHOPIFY_CASH_INVOICE: 'shopifyCashInvoice',
  TRANSACTION_TYPE_SHOPIFY_CASH_CANCELLATION: 'shopifyCashCancellation',
  TRANSACTION_TYPE_SHOPIFY_CASH_CREDIT_NOTE: 'shopifyCashCreditNote',
  TRANSACTION_TYPE_SHOPIFY_CASH_ORDER: 'shopifyCashOrder',
  TRANSACTION_TYPE_REFUND_INVOICE: 'refundInvoice',
  TRANSACTION_TYPE_REFUND_ORDER: 'refundOrder',
  TRANSACTION_TYPE_ARTICLE: 'article',
  TRANSACTION_TYPE_PROJECT: 'project',
  TRANSACTION_TYPE_LETTER: 'letter',
  TRANSACTION_TYPE_PURCHASE: 'purchase',
}

export const transactionSettingTabs = {
  INVOICE_CREATION: 'invoiceCreation',
  E_INVOICE_SETTINGS: 'eInvoiceSettings',
}

export const columnNames = {
  DESCRIPTION: 'description',
  NUMBER: 'number',
  AMOUNT: 'amount',
  VAT: 'vat',
  PRICE: 'price',
  DISCOUNT: 'discount',
  TOTAL: 'total',
}

export const columnPlaceholders = {
  DESCRIPTION: 'Bezeichnung',
  NUMBER: 'Artikel-Nr.',
  AMOUNT: 'Menge',
  VAT: 'USt.',
  PRICE: 'Preis',
  DISCOUNT: 'Rabatt',
  TOTAL: 'Gesamt',
}

export const htmlInputEmptyStates = {
  DEFAULT_HTML_EMPTY_STATE: '<p><br></p>',
  HTML_LIST_EMPTY_STATE: '<ul><li><br></li></ul>',
}

export const notificationTypes = {
  NOTIFICATION_TYPE_EMAIL: 'email',
  NOTIFICATION_TYPE_SMARTPHONE: 'smartphone',
}

export const notificationTemplates = {
  MAILBOX_MESSAGES_PROCESSED: 'mailboxMessagesProcessed',
}

export const registrationStates = {
  NOT_CONFIRMED: 'notConfirmed',
  NOT_CONFIRMED_ERROR: 'notConfirmedError',
}

export const letterHeaderStates = {
  LETTER_HEADER_EMPTY_STATE: 'empty',
  LETTER_HEADER_DISPLAY_STATE: 'display',
  LETTER_HEADER_EDIT_STATE: 'edit',
}

export const letterHeaderConstants = {
  DEFAULT_FONT_SIZE: 18,
}

export const subscriptionTypes = {
  TRIAL: 'trial',
  PREMIUM: 'premium',
  PREMIUM_CHRISTMAS_DISCOUNT: 'premium_christmas_discount',
  S: 's',
  M: 'm',
  L: 'l',
  S_2021: 's_2021',
  M_2021: 'm_2021',
  L_2021: 'l_2021',
  S_2021_2: 's_2021_2',
  M_2021_2: 'm_2021_2',
  L_2021_2: 'l_2021_2',
  XL_2021: 'xl_2021',
  FREE_2025: 'free_2025',
  XS_2025: 'xs_2025',
  S_2025: 's_2025',
  M_2025: 'm_2025',
  L_2025: 'l_2025',
  BUCHHALTUNG_2026: 'buchhaltung_2026',
  AUFTRAG_2026: 'auftrag_2026',
  AUFTRAG_PRO_2026: 'auftragPro_2026',
  WARENWIRTSCHAFT_2026: 'warenwirtschaft_2026',
  TAX_CONSULTANT_2023_03: 'taxconsultant_2023_03',
  TAX_CONSULTANT_DEMO: 'taxconsultant_demo',
  TAX_CONSULTANT_CLIENT_OFFLINE: 'taxconsultant_client_offline_2023_05',
  TAX_CONSULTANT_CLIENT_FREE: 'taxconsultant_client_2023_05',
  DOCUMENT_TRIAL: 'document_trial',
  DOCUMENT_S: 'document_s',
  DOCUMENT_M: 'document_m',
  DOCUMENT_L: 'document_l',
  DOCUMENT_L_ERP: 'document_l_erp',
  DOCUMENT_XL: 'document_xl',
  STAFF_TRIAL: 'staff_trial',
  STAFF_S: 'staff_s',
  STAFF_M: 'staff_m',
  STAFF_L: 'staff_l',
  STAFF_XL: 'staff_xl',
}

export const subscriptionTypesGMI = {
  GMI_S: 'gmi-s',
  GMI_M: 'gmi-m',
  GMI_L: 'gmi-l',
}

export const subscriptionModuleTypes = {
  GMI: 'gmi',
}

export const subscriptionLimits = {
  APPS_NOTINPLAN: 'limitation.notInPlan.apps',
  ARTICLES_NOTINPLAN: 'limitation.notInPlan.articles',
  BANKING_NOTINPLAN: 'limitation.notInPlan.banking',
  BOOKINGSUMMARY_NOTINPLAN: 'limitation.notInPlan.bookingSummary',
  CASH_REGISTER_NOTINPLAN: 'limitation.notInPlan.cashRegister',
  CASH_TSS_NOTINPLAN: 'limitation.notInPlan.cashTSS',
  CASHREGISTER_NOTINPLAN: 'limitation.notInPlan.cashRegister',
  CUSTOMER_COUNT: 'limitation.customerCount',
  DASHBOARD_NOTINPLAN: 'limitation.notInPlan.dashboard',
  DATA_IMPORT_NOTINPLAN: 'limitation.notInPlan.dataImport',
  DEFAULT_NOTINPLAN: 'limitation.notInPlan.default',
  DELIVERYNOTES_NOTINPLAN: 'limitation.notInPlan.deliveryNotes',
  DOCUMENT_EXPORT_NOTINPLAN: 'limitation.notInPlan.documentExport',
  DOCUMENT_SCAN_COUNT: 'limitation.documentScanCount',
  DOCUMENT_SCAN_COUNT_INFO: 'limitation.documentScanCountInfo',
  DOCUMENT_SCANS_INTERN_NOTINPLAN: 'limitation.notInPlan.documentScansIntern',
  DOCUMENT_SCANS_NOTINPLAN: 'limitation.notInPlan.documentScans',
  DOCUMENT_SCANS_TRIAL_NOTINPLAN: 'limitation.notInPlan.documentScansTrial',
  DOCUMENTS_NOTINPLAN: 'limitation.notInPlan.documents',
  DUNNING_NOTINPLAN: 'limitation.notInPlan.dunning',
  EXPENSES_NOTINPLAN: 'limitation.notInPlan.expenses',
  FINANCE_NOTINPLAN: 'limitation.notInPlan.finance',
  INVOICE_COUNT: 'limitation.invoiceCount',
  MASTERDATA_NOTINPLAN: 'limitation.notInPlan.masterData',
  MORE_SETTINGS_NOTINPLAN: 'limitation.notInPlan.moreSettings',
  MULTI_USER_NOTINPLAN: 'limitation.notInPlan.multiUser',
  OFFERS_NOTINPLAN: 'limitation.notInPlan.offers',
  ORDERSANDDELIVERYNOTES_NOTINPLAN: 'limitation.notInPlan.ordersanddeliverynotes',
  PROJECTS_NOTINPLAN: 'limitation.notInPlan.projects',
  RECURRING_INVOICES_NOTINPLAN: 'limitation.notInPlan.recurringInvoices',
  SALES_BORDER: 'limitation.salesBorder',
  SHIPPING_CONNECTION_NOTINPLAN: 'limitation.notInPlan.shippingConnection',
  SHOP_CONNECTION_NOTINPLAN: 'limitation.notInPlan.shopConnection',
  SHOP_COUNT: 'limitation.shop',
  SMTPIMAPACCOUNT_NOTINPLAN: 'limitation.notInPlan.smtpImapAccount',
  STOCKMANAGEMENT_NOTINPLAN: 'limitation.notInPlan.stockKeeping',
  GRADUATEDPRICES_NOTINPLAN: 'limitation.notInPlan.graduatedPrices',
  STORAGE_SPACE: 'limitation.storageSpace',
  STORAGE_SPACE_INFO: 'limitation.storageSpaceInfo',
  DOCUMENT_COUNT: 'limitation.documentCount',
  DOCUMENT_COUNT_YEAR: 'limitation.documentCountYear',
  TIMETRACKING_NOTINPLAN: 'limitation.notInPlan.timetracking',
  TODOS_NOTINPLAN: 'limitation.notInPlan.todos',
  VATRETURN_NOTINPLAN: 'limitation.notInPlan.vatReturn',
  REPORTING_NOTINPLAN: 'limitation.notInPlan.reporting',
  DOCUMENT_COUNT_INFO: 'limitation.documentCountInfo',
}

export const subscriptionLimitationNames = {
  STORAGE_SPACE: 'storageSpace',
  DOCUMENT_COUNT: 'documentCount',
  DOCUMENT_PACKAGE_COUNT: 'documentPackageCount',
  DOCUMENT_COUNT_YEAR: 'documentCountYear',
  MULTI_USER: 'multiUser',
  CASH_REGISTER: 'cashRegister',
  SHOP: 'shop',
  SHIPPING: 'shipping',
  SCANS: 'scans',
  GMI: 'gmi',
}

export const paymentTypes = {
  DEBIT: 'debit',
  PAYPAL: 'payPal',
}

export const paymentProvider = {
  STRIPE: 'stripe',
  PAYPAL: 'paypal',
}

export const paymentStatus = ['COMPLETED', 'paid']

export const priceKinds = {
  NET: 'net',
  GROSS: 'gross',
}

export const settingsLogo = {
  EMAIL: 'email',
  CUSTOMER_CENTER: 'customerCenter',
}

// banking
export const bookingAssignmentsProceedingTypes = {
  CUSTOMER_CREDIT: 'customerCredit',
  SURCHARGE: 'surcharge',
  PARTIAL: 'partial',
  DISCOUNT: 'discount',
  BANK_CHARGE: 'bankCharge',
  ADD_TRANSACTION: 'addTransaction',
  BOOK_LATER: 'bookLater',
}
export const bankAccountTypes = {
  CASH_JOURNAL: 'cashJournal',
  CLEARING_ACCOUNT: 'clearingAccount',
  GIRO: 'giro',
  PAY_PAL: 'payPal',
  CREDIT_CARD: 'creditCard',
  CREDIT: 'credit',
}
export const assignmentDetailTypes = {
  ASSIGNMENTS: 'assignments',
  EXPENSE_FORM: 'expenseForm',
  SELECTION: 'selection',
  SELECTION_INVOICE: 'selectionInvoice',
  INTERNAL_BANK_TRANSFER: 'internalBankTransfer',
}

export const transferTypes = {
  CREATE_NEW: 'createNew',
  ASSIGN_EXISTING: 'assignExisting',
}

export const orderSourceTypes = {
  MANUAL: 'manual',
  ECOMMERCE: 'ecommerce',
}

export const orderTypes = {
  ORDER: 'order',
  REFUND_ORDER: 'refundOrder',
}

export const DEFAULT_EMPTY_ADDRESS_OBJECT = {
  salutation: '',
  title: '',
  firstName: '',
  lastName: '',
  name: '',
  companyName: '',
  companyNameAffix: '',
  street: '',
  city: '',
  zipCode: '',
  countryIso: 'DE',
  kind: customerTypes.COMPANY,
  isDefault: false,
}

export const DEFAULT_EMPTY_CONTACT_PERSON_OBJECT = {
  salutation: '',
  title: '',
  firstName: '',
  lastName: '',
  phone1: '',
  phone2: '',
  mobile: '',
  fax: '',
  job: '',
  email: '',
  birthday: '',
  isMainContact: false,
}

export const DEFAULT_EMPTY_PAYMENT_CONDITION_OBJECT = {
  name: '',
  dueDays: 0,
  offerText: '',
  invoiceText: '',
  orderText: '',
  isDefault: false,
}

export const DEFAULT_EMPTY_DELIVERY_CONDITION_OBJECT = {
  name: '',
  deliveryDays: 0,
  text: '',
  isDefault: false,
}

export const assignmentTypes = {
  BOOKING: 'booking',
  CANCELLATION: 'cancellation',
  CREDIT_NOTE: 'creditNote',
  EXPENSE: 'expense',
  INVOICE: 'invoice',
  DISCOUNT: 'discount',
  REVENUE: 'revenue',
  SURCHARGE: 'surcharge',
  FEE: 'fee',
  BANK_CHARGE: 'bankcharge',
}

// expense states
export const expenseStates = {
  IN_PROGRESS: 'inProgress',
  OPEN: 'open',
  PAID: 'paid',
  PARTIALLYPAID: 'partiallyPaid',
  ISOVERDUE: 'isOverDue',
  ISDUE: 'isDue',
  DRAFT: 'draft',
  TO_ANALYZE: 'toAnalyze',
  ANALYZE_ERROR: 'analyzeError',
}
export const revenueStates = {
  OPEN: 'open',
  PAID: 'paid',
  PARTIALLYPAID: 'partiallyPaid',
  DRAFT: 'draft',
  TO_ANALYZE: 'toAnalyze',
  ANALYZE_ERROR: 'analyzeError',
}
export const receiptStates = {
  ...expenseStates,
  ...revenueStates,
}

export const taxTypes = {
  IS_SUBJECT_TO_IMPUTED_TAX_TRUE: 'isSubjectToImputedTaxationTrue',
  IS_SUBJECT_TO_IMPUTED_TAX_FALSE: 'isSubjectToImputedTaxationFalse',
  SMALL_BUSINESS: 'isSmallBusiness',
  VAT_EXEMPT: 'vatExempt',
}

export const mimeTypes = {
  MIMETYPE_JPG: 'image/jpeg',
  MIMETYPE_JPEG: 'image/jpg',
  MIMETYPE_PNG: 'image/png',
  MIMETYPE_BMP: 'image/bmp',
  MIMETYPE_PDF: 'application/pdf',
  MIMETYPE_ZIP: 'application/zip',
  MIMETYPE_XML: 'application/xml',
  MIMETYPE_TEXT_XML: 'text/xml',
  MIMETYPE_CSV: 'text/csv',
  MIMETYPE_OCTET_STREAM: 'application/octet-stream',
  MIMETYPE_DOC: 'application/msword',
  MIMETYPE_DOCX: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  MIMETYPE_XLS: 'application/vnd.ms-excel',
  MIMETYPE_XLSX: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  MIMETYPE_PPT: 'application/vnd.ms-powerpoint',
  MIMETYPE_PPTX: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  MIMETYPE_X_ZIP_COMPRESSED: 'application/x-zip-compressed',
}

export const searchResultTypes = {
  ARTICLE: 'article',
  CANCELLATION: 'cancellation',
  CREDIT_NOTE: 'creditNote',
  CUSTOMER: 'customer',
  DELIVERYNOTE: 'deliveryNote',
  DUNNING: 'dunning',
  EXPENSE: 'expense',
  INVOICE: 'invoice',
  OFFER: 'offer',
  ORDER: 'order',
  PROJECT: 'project',
  RECURRINGINVOICE: 'recurringInvoice',
  REVENUE: 'revenue',
  SUPPLIER: 'supplier',
  TRACKEDTIME: 'trackedTime',
  LETTER: 'letter',
  PURCHASE: 'purchase',
}

export const FILE_TYPE = {
  DOCUMENT: 'document',
  INVOICE: 'invoice',
  CANCELLATION: 'cancellation',
}

export const FILE_LIST_FILTER = {
  ALL: 'all',
  NO_INVOICES: 'noInvoices',
  NOT_ASSIGNED: 'notAssigned',
  ONLY_DOCUMENTS: 'onlyDocuments',
  ASSIGNED: 'assigned',
  FAVORITE: 'favorite',
  APPROVED: 'approved',
  LASTUPDATED: 'lastUpdated',
  MANUALLYPAID: 'manuallyPaid',
  NO_SYSTEM_DOCUMENTS: 'noSystemDocuments',
}

export const sourceTypes = {
  MANUAL: 'manual',
  SHOPIFY: 'shopify',
  SHOPWARE: 'shopware',
}

export const shopTypes = {
  EPAGES: 'epages',
  SHOPIFY: 'shopify',
  SHOPWARE: 'shopware',
}

export const ecommercePaymentStates = {
  PAID: 'paid',
}

export const fulfillmentStates = {
  FULFILLED: 'fulfilled',
}

export const experimentalFeatures = {
  transactionEditV2: 'transactionEditV2',
  moduleSubscription: 'moduleSubscription',
  marketPlace: 'marketPlace',
  letters: 'letters',
  csatDocuments: 'csatDocuments',
  csatDocumentsSearch: 'csatDocumentsSearch',
  analyticsExpenseRevenue: 'analyticsExpenseRevenue',
  analyticsNatif: 'analyticsNatif',
  cello: 'cello',
  dmsDirectUpload: 'dmsDirectUpload',
  useDocuAi: 'useDocuAi',
  // FLAG:docuAiEnhancements — internal-only child of useDocuAi (customer issue reporting, receipt chat).
  // The server only puts it in the JWT when useDocuAi is also on — check the child alone.
  docuAiEnhancements: 'docuAiEnhancements',
  documentToolbarV2: 'documentToolbarV2',
  universalCallBackV2: 'universalCallBackV2',
  analyticText: 'analyticText',
  folderPermissions: 'folderPermissions',
  directDebit: 'directDebit',
}

export const logoUploadTargets = {
  CUSTOMER_CENTER: 'customerCenter',
  EMAIL: 'email',
  TAX_CONSULTANT: 'taxconsultant',
}

export const documentFileExtensions = {
  ALLOWED_FILE_EXTENSIONS: ['pdf'],
}

/* eslint-disable no-useless-escape */
export const customEmailRegex = /^[A-Za-z0-9.!#$%&'*+\-\/=?^_`{|}~]+@[^!@#$%^&*();:,?\/\\=+<> \[\]]+\.[A-Za-z]{2,}$/i

export const accountNoExistsRegex = /An account no (\d+) already exists./
export const accountNotInRangeRegex = /(\d+) not in range \[10000...69999\]/
export const emailAttachmentDocumentTypes = ['invoice', 'offer', 'order', 'recurringInvoice']

const OWNER_ROLE = 'OWNER'
const ADMIN_ROLE = 'ADMIN'
const TAX_CONSULTANT_ROLE = 'TAX_CONSULTANT'
const TAX_CONSULTANT_ROLE_ADMIN = 'TAX_CONSULTANT_ADMIN'
const SALES_ROLE = 'SALES'
const FINANCE_ROLE = 'FINANCE'
const DOCUMENTS_ROLE = 'DOCUMENTS'
const STAFF_ROLE = 'STAFF'

export const EMPTY_PROP = '–'

export const ADMIN_ROLES = [
  OWNER_ROLE,
  ADMIN_ROLE,
]

export const ROLES = {
  OWNER_ROLE,
  ADMIN_ROLE,
  TAX_CONSULTANT_ROLE_ADMIN,
  DOCUMENTS_ROLE,
  TAX_CONSULTANT_ROLE,
  SALES_ROLE,
  FINANCE_ROLE,
  STAFF_ROLE,
}

export const USER_RIGHTS = {
  ACCOUNTANT_EXPORT: {
    CREATE: 'accountant_export.create',
    DELETE: 'accountant_export.delete',
    READ: 'accountant_export.read',
    WRITE: 'accountant_export.write',
  },
  ACCOUNTING: {
    BANKING_AGREEMENT: 'accounting.banking_agreement',
    BANKING_ASSIGNMENT: 'accounting.banking_assignment',
    BANKING_BANK: 'accounting.banking_bank',
    BANKING_BANK_TRANSFER: 'accounting.banking_bank_transfer',
    BANKING_BANK_TRANSFER_INTERNAL: 'accounting.banking_bank_transfer_internal',
    BANKING_BOOKING: 'accounting.banking_booking',
    BANKING_CASH_JOURNAL: 'accounting.banking_cash_journal',
    BANKING_CHART_OF_ACCOUNTS: 'accounting.banking_chart_of_accounts',
    BANKING_OFFLINE: 'accounting.banking_offline',
    BANKING_PIN: 'accounting.banking_pin',
    BANKING_SETUP: 'accounting.banking_setup',
    BANKING_TAN: 'accounting.banking_tan',
    BANKING_TRANSACTION: 'accounting.banking_transaction',
    CREATE: 'accounting.create',
    CREDIT_NOTE_PAYMENT: 'accounting.credit_note_payment',
    DELETE: 'accounting.delete',
    EXPENSE: 'accounting.expense',
    EXPENSE_PAYMENT: 'accounting.expense_payment',
    INVOICE_PAYMENT: 'accounting.invoice_payment',
    READ: 'accounting.read',
    REPORTING: 'accounting.reporting',
    REVENUE_PAYMENT: 'accounting.revenue_payment',
    TRANSACTIONS: 'accounting.transactions',
    WRITE: 'accounting.write',
  },
  APPS: {
    CREATE: 'apps.create',
    DELETE: 'apps.delete',
    READ: 'apps.read',
    WRITE: 'apps.write',
  },
  ARTICLES: {
    CREATE: 'articles.create',
    DELETE: 'articles.delete',
    READ: 'articles.read',
    WRITE: 'articles.write',
  },
  CASH_POS: {
    CREATE: 'cash_pos.create',
    DELETE: 'cash_pos.delete',
    READ: 'cash_pos.read',
    WRITE: 'cash_pos.write',
  },
  CLIENTS: {
    CREATE: 'clients.create',
    DELETE: 'clients.delete',
    READ: 'clients.read',
    WRITE: 'clients.write',
  },
  CUSTOMERS: {
    CREATE: 'customers.create',
    DELETE: 'customers.delete',
    FIND: 'customers.find',
    READ: 'customers.read',
    WRITE: 'customers.write',
  },
  DELIVERY_NOTES: {
    CREATE: 'delivery_notes.create',
    DELETE: 'delivery_notes.delete',
    READ: 'delivery_notes.read',
    WRITE: 'delivery_notes.write',
  },
  DOCUMENTS: {
    CREATE: 'documents.create',
    DELETE: 'documents.delete',
    READ: 'documents.read',
    WRITE: 'documents.write',
  },
  ECONOMIC_ASSETS: {
    CREATE: 'economic_assets.create',
    DELETE: 'economic_assets.delete',
    READ: 'economic_assets.read',
    WRITE: 'economic_assets.write',
  },
  EXPENSES: {
    CREATE: 'expenses.create',
    DELETE: 'expenses.delete',
    READ: 'expenses.read',
    WRITE: 'expenses.write',
  },
  FINANCE_FORMS: {
    CREATE: 'finance_forms.create',
    DELETE: 'finance_forms.delete',
    READ: 'finance_forms.read',
    WRITE: 'finance_forms.write',
  },
  INVOICES: {
    CREATE: 'invoices.create',
    DELETE: 'invoices.delete',
    READ: 'invoices.read',
    WRITE: 'invoices.write',
  },
  LETTERS: {
    CREATE: 'letters.create',
    DELETE: 'letters.delete',
    READ: 'letters.read',
    WRITE: 'letters.write',
  },
  MEMBERS: {
    CREATE: 'members.create',
    DELETE: 'members.delete',
    LOCK: 'members.lock',
    READ: 'members.read',
    WRITE: 'members.write',
  },
  OFFERS: {
    CREATE: 'offers.create',
    DELETE: 'offers.delete',
    READ: 'offers.read',
    WRITE: 'offers.write',
  },
  ORDERS: {
    CREATE: 'orders.create',
    DELETE: 'orders.delete',
    READ: 'orders.read',
    WRITE: 'orders.write',
  },
  PROJECTS: {
    CREATE: 'projects.create',
    DELETE: 'projects.delete',
    READ: 'projects.read',
    WRITE: 'projects.write',
  },
  PURCHASES: {
    CREATE: 'purchases.create',
    DELETE: 'purchases.delete',
    READ: 'purchases.read',
    WRITE: 'purchases.write',
  },
  RECURRING_INVOICES: {
    CREATE: 'recurring_invoices.create',
    DELETE: 'recurring_invoices.delete',
    READ: 'recurring_invoices.read',
    WRITE: 'recurring_invoices.write',
  },
  REVENUES: {
    CREATE: 'revenues.create',
    DELETE: 'revenues.delete',
    READ: 'revenues.read',
    WRITE: 'revenues.write',
  },
  SHIPPINGS: {
    CREATE: 'shippings.create',
    DELETE: 'shippings.delete',
    READ: 'shippings.read',
    WRITE: 'shippings.write',
  },
  SETTINGS: {
    ACCOUNT: 'settings.account',
    ARTICLE: 'settings.article',
    BANKING: 'settings.banking',
    CREATE: 'settings.create',
    CUSTOMER: 'settings.customer',
    DELETE: 'settings.delete',
    DELIVERY_CONDITION: 'settings.delivery_condition',
    DELIVERY_NOTE: 'settings.delivery_note',
    DUNNING: 'settings.dunning',
    ECOMMERCE: 'settings.ecommerce',
    INTERFACES: 'settings.interfaces',
    INVOICE: 'settings.invoice',
    LETTER: 'settings.letter',
    LETTER_PAPER: 'settings.letter_paper',
    OFFER: 'settings.offer',
    ORDER: 'settings.order',
    PAY_CONDITION: 'settings.pay_condition',
    READ: 'settings.read',
    STATISTICS: 'settings.statistics',
    TENANT: 'settings.use_tenant',
    WIDGET: 'settings.widget',
    WRITE: 'settings.write',
  },
  STAFF: {
    CREATE: 'staff.create',
    DELETE: 'staff.delete',
    READ: 'staff.read',
    WRITE: 'staff.write',
  },
  SUBSCRIPTIONS: {
    CREATE: 'subscriptions.create',
    DELETE: 'subscriptions.delete',
    READ: 'subscriptions.read',
    WRITE: 'subscriptions.write',
  },
  SUPPLIERS: {
    CREATE: 'suppliers.create',
    DELETE: 'suppliers.delete',
    FIND: 'suppliers.find',
    READ: 'suppliers.read',
    WRITE: 'suppliers.write',
  },
  TAX_FORMS: {
    CREATE: 'tax_forms.create',
    DELETE: 'tax_forms.delete',
    READ: 'tax_forms.read',
    WRITE: 'tax_forms.write',
  },
  TODOS: {
    CREATE: 'todos.create',
    DELETE: 'todos.delete',
    READ: 'todos.read',
    WRITE: 'todos.write',
  },
  TRACKED_TIMES: {
    CREATE: 'tracked_times.create',
    DELETE: 'tracked_times.delete',
    READ: 'tracked_times.read',
    WRITE: 'tracked_times.write',
  },
  VAT_RETURN: {
    CREATE: 'vat_return.create',
    DELETE: 'vat_return.delete',
    READ: 'vat_return.read',
    WRITE: 'vat_return.write',
  },
}

// Maps settings sub-area route tokens to concrete USER_RIGHTS.
// Tokens without a dedicated settings right fall back to the generic
// settings.read / settings.write pair (see docs/settings-fallback.md).
export const SETTINGS_RIGHTS = {
  ACCOUNT: { READ: USER_RIGHTS.SETTINGS.READ, WRITE: USER_RIGHTS.SETTINGS.WRITE },
  COMPANY: { READ: USER_RIGHTS.SETTINGS.READ, WRITE: USER_RIGHTS.SETTINGS.WRITE },
  CUSTOMER_CENTER: { READ: USER_RIGHTS.SETTINGS.READ, WRITE: USER_RIGHTS.SETTINGS.WRITE },
  MASTERDATA: { READ: USER_RIGHTS.SETTINGS.READ, WRITE: USER_RIGHTS.SETTINGS.WRITE },
  CUSTOM_FIELDS: { READ: USER_RIGHTS.SETTINGS.READ, WRITE: USER_RIGHTS.SETTINGS.WRITE },
  MISCELLANEOUS: { READ: USER_RIGHTS.SETTINGS.READ, WRITE: USER_RIGHTS.SETTINGS.WRITE },
  EVENT_LOG: { READ: USER_RIGHTS.SETTINGS.READ, WRITE: USER_RIGHTS.SETTINGS.WRITE },
  NUMERATION: { READ: USER_RIGHTS.SETTINGS.READ, WRITE: USER_RIGHTS.SETTINGS.WRITE },
  TAX_ACCOUNTANT: { READ: USER_RIGHTS.SETTINGS.READ, WRITE: USER_RIGHTS.SETTINGS.WRITE },
  TEXT_MODULE: { READ: USER_RIGHTS.SETTINGS.READ, WRITE: USER_RIGHTS.SETTINGS.WRITE },
  TAG: { READ: USER_RIGHTS.SETTINGS.READ, WRITE: USER_RIGHTS.SETTINGS.WRITE },
  LETTER_PAPER: { READ: USER_RIGHTS.SETTINGS.LETTER_PAPER, WRITE: USER_RIGHTS.SETTINGS.LETTER_PAPER },
  INTERFACES: { READ: USER_RIGHTS.SETTINGS.INTERFACES, WRITE: USER_RIGHTS.SETTINGS.INTERFACES },
  DELIVERY_CONDITION: { READ: USER_RIGHTS.SETTINGS.DELIVERY_CONDITION, WRITE: USER_RIGHTS.SETTINGS.DELIVERY_CONDITION },
  PAY_CONDITION: { READ: USER_RIGHTS.SETTINGS.PAY_CONDITION, WRITE: USER_RIGHTS.SETTINGS.PAY_CONDITION },
  ECOMMERCE: { READ: USER_RIGHTS.SETTINGS.ECOMMERCE, WRITE: USER_RIGHTS.SETTINGS.ECOMMERCE },
  TENANT: { READ: USER_RIGHTS.SETTINGS.TENANT, WRITE: USER_RIGHTS.SETTINGS.TENANT },
}

export const SUBSCRIPTION_MODULES = {
  BANKING: 'BANKING',
  BOOKINGSUMMARY: 'BOOKINGSUMMARY',
  CASH_REGISTER: 'CASHREGISTER',
  CASH_TSS: 'CASHTSS',
  DIRECT_DEBIT: 'DIRECT_DEBIT',
  DOCUMENT_SCANS_INTERN: 'SCANS',
  DOCUMENT_SCANS_TRIAL: 'SCANS',
  DOCUMENT_SCANS: 'SCANS',
  DOCUMENT_PAYMENT: 'DOCUMENT_PAYMENT',
  DOCUMENT_SIGNATURE: 'DOCUMENT_SIGNATURE',
  DOCUMENTS: 'DOCUMENTS',
  DUNNING: 'DUNNING',
  EXPENSES: 'EXPENSES',
  INVOICES: 'INVOICES',
  MULTITENANT: 'multiTenant',
  GRADUATEDPRICES: 'GRADUATEDPRICES',
  ORDERSANDDELIVERYNOTES: 'ORDERSANDDELIVERYNOTES',
  PROJECTS: 'PROJECTS',
  RECURRING_INVOICES: 'RECURRINGINVOICES',
  REVENUES: 'REVENUES',
  SHIPPING_CONNECTION: 'SHIPPING',
  SHOP_CONNECTION: 'SHOP',
  STOCKMANAGEMENT: 'STOCKMANAGEMENT',
  SUPPLIERS: 'SUPPLIERS',
  TIMETRACKING: 'TIMETRACKING',
  TODOS: 'TODOS',
  VATRETURN: 'VATRETURN',
  TAXFORM_DASHBOARD: 'TAXFORM-DASHBOARD',
  TAXFORM_USTVA: 'taxform-ustva',
  TAXFORM_EUER: 'taxform-euer',
  TAXFORM_TAX_FORM_SETTINGS: 'taxform-taxFormSettings',
  TAXFORM_TAX_FORM_HISTORY_LIST: 'taxform-taxFormHistoryList',
  SMTPIMAPACCOUNT: 'SMTPIMAPACCOUNT',
  REPORTING: 'REPORTING',
  CUSTOMERS: 'CUSTOMERS',
  ARTICLES: 'ARTICLES',
  OFFERS: 'OFFERS',
  MARKETPLACE: 'MARKETPLACE',
  DOCUMENT_EXPORTS: 'DOCUMENTEXPORTS',
  BOOKINGS: 'BOOKINGS',
  CLIENTS: 'CLIENTS',
  SIGNATURES: 'SIGNATURES',
  FINANCEFORM_EXPORT: 'financeform-export',
  FINANCEFORM_EXPORT_DATEV: 'financeform-exportDatev',
  FINANCEFORM_EXPORT_LIST: 'financeform-exportList',
  FINANCEFORM_EXPORT_DATEV_VIEW: 'financeform-exportDatevView',
  FINANCEFORM_EXPORT_DOCUMENTS: 'financeform-exportDocuments',
  STAFF: 'STAFF',
  ECONOMIC_ASSETS: 'ECONOMIC_ASSETS',
  LETTERS: 'LETTERS',
  PURCHASES: 'PURCHASES',
  COLLECTIVE_INVOICE: 'collectiveInvoice',
  AUTO_DUNNING: 'autoDunning',
  OPTIONAL_POSITIONS: 'optionalPositions',
  ALTERNATIVE_POSITIONS: 'alternativePositions',
  MULTI_LETTERPAPER: 'multiLetterPaper',
  AUTO_MAILBOX: 'autoMailbox',
  PARTIAL_INVOICES: 'partialInvoices',
  BACKUP: 'backup',
  COLLECTIVE_DELIVERY_NOTES: 'collectiveDeliveryNotes',
  PUBLIC_API: 'publicApi',
}
export const USER_LIST_WIDGET_STATE = {
  ACTIVE: 'active',
  INVITED: 'invited',
}

export const HUBSPOT_OPTIONS = {
  propertys: {
    CONTACT_SOURCES: 'contactSources',
  },
  crmObjects: {
    CONTACTS: 'contacts',
  },
}

export const EMAIL_ACCOUNT_TYPE = {
  INCOMING: 'incoming',
  OUTGOING: 'outgoing',
}

export const FORBIDDEN_FILENAME_CHARACTERS = ['/', '\\', '?', '%', '*', ':', '|', '"', '<', '>']

export const ProductTypes = {
  MAIN: 'main',
  STAFF: 'staff',
  DOCUMENT: 'document',
  TAX_CONSULTANT: 'taxconsultant',
  ERP: 'erp',
}

export const ProductTypeNames = {
  [ProductTypes.MAIN]: isMeinBuero() ? 'Rechnungen' : 'Buchhaltung',
  [ProductTypes.DOCUMENT]: 'Dokumente',
  [ProductTypes.STAFF]: 'Personal',
}

export const ModuleTypes = {
  MULTI_USER: 'multiUser',
  SIGNATURES: 'signatures',
  TIME_TRACKING: 'timeTracking',
  RECURRING_INVOICES: 'recurringInvoices',
  DIRECT_DEBIT: 'directDebit',
  MULTI_LETTERPAPER: 'multiLetterPaper',
  STORAGE_PACKAGE: 'storagePackage',
  PUBLIC_API: 'publicApi',
}

export const SubscriptionTypeTypes = {
  Main: 'main',
  Staff: 'staff',
  Document: 'document',
  TaxConsultant: 'taxconsultant',
  Desktop: 'desktop',
}

export const SUBSCRIPTION_TYPE_DEMO = 'demo'

const bookkeepingFolder = isMeinBuero() ? 'WISO MeinBüro' : 'orgaMAX Buchhaltung'

export const SystemFolders = {
  FinanceExpense: `${bookkeepingFolder}/Finanzen-Ausgaben`,
  FinanceRevenue: `${bookkeepingFolder}/Finanzen-Sonstige-Einnahmen`,
  Bookkeeping: `${bookkeepingFolder}`,
  Inbox: 'Posteingang',
}

export const MenuItems = {
  Documents: 'documents',
  Staff: 'staff',
  Apps: 'apps',
  ModuleSubscription: 'moduleSubscription',
  Products: 'products',
  Marketplace: 'marketplace',
  Dashboard: 'dashboard',
  Todos: 'todos',
  MasterData: 'masterData',
  Clients: 'clients',
  Customers: 'customers',
  Suppliers: 'suppliers',
  Articles: 'articles',
  DataImport: 'dataImport',
  Disposal: 'disposal',
  Invoices: 'invoices',
  Offers: 'offers',
  Orders: 'orders',
  DeliveryNotes: 'deliveryNotes',
  RecurringInvoices: 'recurringInvoices',
  Projects: 'projects',
  Timetracking: 'timetracking',
  Letters: 'letters',
  Finances: 'finances',
  Banking: 'banking',
  Expenses: 'expenses',
  Revenues: 'revenues',
  DocumentExport: 'documentExport',
  VatReturn: 'vatReturn',
  TaxForms: 'taxForms',
  Booking: 'booking',
  Reporting: 'reporting',
  EconomicAssets: 'economicAssets',
  Settings: 'settings',
  MyAccount: 'myaccount',
  LetterPaper: 'letter-paper',
  CustomerCenter: 'customer-center',
  Interfaces: 'interfaces',
  CustomFields: 'customFields',
  MoreSettings: 'more-settings',
  Users: 'users',
  EventLog: 'event-log',
  Electron: 'electron',
  Upgrade: 'upgrade',
  Extensions: 'extensions',
  Procurement: 'procurement',
  MainBooking: 'mainBooking',
  Mailbox: 'mailbox',
  Office: 'office',
  FirstSteps: 'firstSteps',
  Purchases: 'purchases',
  Obtaining: 'obtaining',
  InvoiceDebitTransactions: 'debitTransactions',
  Backup: 'backup',
  CustomerIssues: 'customerIssues',
}

export const RECEIPT_TYPES = {
  EXPENSE: 'expense',
  REVENUE: 'revenue',
}

export const RECEIPT_PAYMENT_TYPES = {
  ASSIGNMENT: 'assignment',
  BANK_TRANSFER: 'bankTransfer',
  BOOKING: 'booking',
}

export const SUBSCRIPTION_DISCOUNT_APPLY_FOR = {
  PROSPECT: 'prospect',
  EXISTING_CUSTOMER: 'existingCustomer',
  PROSPECT_AND_EXISTING_CUSTOMER: 'prospectAndExistingCustomer',
}

export const MAIL_ATTACHMENT_CONVERT_TO = {
  EXPENSE: 'expense',
  DOCUMENT: 'document',
}

export const SIGNATURE_FIELD_TYPES = {
  SIGNATURE: 'signature',
  DATE: 'date',
  TEXT: 'text',
}

export const TODO_COLLABORATION_ID = {
  INTERNAL: 'internal',
}

export const ICON_LABELS = {
  SEARCH_ENGINE: 'Suchmaschine (Google/Bing)',
  RECOMMENDATION: 'Empfehlung',
  OMR_REVIEWS: 'OMR Reviews',
  PODCAST: 'Podcast',
  LINKEDIN: 'LinkedIn',
  FACEBOOK: 'Facebook',
  INSTAGRAM: 'Instagram',
  TIKTOK: 'TikTok',
  YOUTUBE: 'Youtube',
  EVENT: 'Messe/Event',
  OTHER: 'Sonstiges',
}

export const EInvoiceSettingsSections = {
  Customer: 'customer',
  BankAccount: 'bankAccount',
  ContactPerson: 'contactPerson',
  TaxInformation: 'taxInformation',
}

export const noMobileAdvice = [
  '/shop',
  '/login',
  '/account',
]

export const DEFAULT_UNIT = 'Stk.'

export const undoDeletionErrorCodes = {
  EXPIRED: 'EXPIRED',
  INVALID: 'INVALID',
  NOT_FOUND: 'NOT_FOUND',
  ALREADY_UNDELETED: 'ALREADY_UNDELETED',
}

export const ArticleKinds = {
  SalesAndPurchase: 'salesAndPurchase',
  Purchase: 'purchase',
  Sales: 'sales',
}

export const PERMISSION_TYPES = {
  CREATE: 'create',
  UPDATE: 'update',
  MOVE: 'move',
  DELETE: 'delete',
}
